import React from "react";
import PropTypes from "prop-types";
import Badge from "@dtci/spellbook/Badge";

const PromoCellRenderer = ({ value, data }) => {
  const { hasPendingChange } = data;
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      <span>{value}</span>
      {hasPendingChange && (
        <Badge color="error" shape="status" size="smaller">
          Changes
        </Badge>
      )}
    </div>
  );
};

PromoCellRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    hasChanges: PropTypes.bool,
  }),
};

export default PromoCellRenderer;
